import { sql } from "drizzle-orm";
import { pgTable, uuid, text, integer, jsonb, timestamp, primaryKey, check } from "drizzle-orm/pg-core";

export const marketPullRuns = pgTable("market_pull_runs", {
  id: uuid("id").primaryKey(),
  dataMonth: text("data_month").notNull().unique("market_pull_runs_data_month_key"),
  monthKey: integer("month_key").notNull().unique("market_pull_runs_month_key_key"),
  requestToken: uuid("request_token").notNull(),
  status: text("status").notNull(),
  state: jsonb("state").notNull(),
}, table => [
  check("market_pull_runs_status_check", sql`${table.status} IN ('requested','collected','published','failed')`),
  check("market_pull_runs_identity_check", sql`${table.state}->>'id'=${table.id}::text AND ${table.state}->>'month'=${table.dataMonth} AND ${table.state}->>'token'=${table.requestToken}::text AND ${table.state}->>'status'=${table.status}`),
]);
export const marketPullResults = pgTable("market_pull_results", {
  runId: uuid("run_id").notNull().references(() => marketPullRuns.id),
  requestToken: uuid("request_token").notNull(),
  batch: jsonb("batch").notNull(),
}, table => [primaryKey({ name: "market_pull_results_pkey", columns: [table.runId, table.requestToken] })]);
export const marketPullNotifications = pgTable("market_pull_notifications", {
  eventId: text("event_id").primaryKey(),
  report: jsonb("report").notNull(),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  deliveredAt: timestamp("delivered_at", { withTimezone: true }),
});
